export function getPossessive(subject: string): string {
  const lastCharacter = subject.slice(-1).toLowerCase();
  return lastCharacter === 's' ? subject + "'" : subject + "'s";
}
